module.exports = __webpack_public_path__ + "img/logo4.4f3c803e.png";